import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Switch,
  Box,
  Skeleton,
  useTheme,
  Divider,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomTypography from 'components/Fileds/CustomTypography';
import IOSSwitch from 'components/Fileds/IOSSwitch';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

const CategoryCard = ({
  title,
  itemCount,
  description,
  enabled,
  onEdit,
  onDelete,
  onToggle,
  loading = false,
  toggleDisabled = false,
  isSwitch = true,
  isCount = false,
  countLabel = ''
}) => {
  const theme = useTheme();
  return (
    // <Card variant="outlined" sx={{ height: '100%', borderRadius:'5px', border:'1px solid #CBCBCB' }}>
    //   <CardContent className='d-flex align-items-center justify-content-between' sx={{p:1}}>
    //     <Box>
    //       {loading ? (
    //         <>
    //           <Skeleton variant="text" width={120} height={32} />
    //           <Skeleton variant="text" width={80} height={20} />
    //         </>
    //       ) : (
    //         <>
    // <CustomTypography
    //     variant={"h6"}
    //     label={title}
    //     sx={{color: theme.palette.typographyLabel.main, fontSize:'18px', fontWeight:500, mb: 0.5}}
    // />
    // <CustomTypography
    //     variant={"body2"}
    //     label={`${itemCount || 9} Food Items`}
    //     sx={{color: theme.palette.typographyLabel.main, fontSize:'16px', fontWeight: 300, mb: 0}}
    // />
    //         </>
    //       )}
    //     </Box>

    //     <Box className='d-flex align-items-center'>
    //       {loading ? (
    //         <>
    //           <Skeleton variant="circular" width={32} height={32} sx={{ mx: 0.5 }} />
    //           <Skeleton variant="circular" width={32} height={32} sx={{ mx: 0.5 }} />
    //           <Skeleton variant="rectangular" width={40} height={24} sx={{ borderRadius: 12, mx: 0.5 }} />
    //         </>
    //       ) : (
    //         <>
    //   <IconButton onClick={onEdit} size="small">
    //     <EditIcon fontSize="small" />
    //   </IconButton>
    //   <IconButton onClick={onDelete} color="error" size="small">
    //     <DeleteIcon fontSize="small" />
    //   </IconButton>
    //   <Switch checked={enabled} onChange={onToggle} />
    //         </>
    //       )}
    //     </Box>
    //   </CardContent>
    // </Card>

    // <Box className='d-flex align-items-center justify-content-between' sx={{ height: '100%', borderRadius: '5px', border: '1px solid #CBCBCB', padding: 1.5 }}>
    //   <Box>
    //     <CustomTypography
    //       variant={"h6"}
    //       label={title}
    //       sx={{ color: theme.palette.typographyLabel.main, fontSize: '16px', fontWeight: 600, mb: 0.5 }}
    //     />
    //     {itemCount?.toString() &&
    //       <CustomTypography
    //         variant={"body2"}
    //         label={`${itemCount} ${isCount ? 'Chefs' : 'Food Items'}`}
    //         sx={{ color: theme.palette.typographyLabel.main, fontSize: '14px', fontWeight: 300, mb: 0 }}
    //       />
    //     }
    //     {description &&
    //       <CustomTypography
    //         variant={"body2"}
    //         label={description}
    //         sx={{
    //           color: theme.palette.typographyLabel.main, fontSize: '14px', fontWeight: 300, mb: 0,
    //           maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
    //         }}
    //       />
    //     }

    //   </Box>
    //   <Box>
    //     <IconButton onClick={onEdit} size="small">
    //       <EditIcon fontSize="small" sx={{ color: '#1297DE' }} />
    //     </IconButton>
    //     <IconButton onClick={onDelete} size="small">
    //       <DeleteIcon fontSize="small" sx={{ color: '#FF0202', mr: 0.5 }} />
    //     </IconButton>
    //     {/* <Switch checked={enabled} onChange={onToggle} sx={{color:'#1F9619'}}
    //             disabled={toggleDisabled}
    //           /> */}
    //     {/* <IOSSwitch checked={enabled} onChange={onToggle} 
    //             disabled={toggleDisabled}
    //            /> */}

    //     {isSwitch && <IOSSwitch checked={enabled} onChange={onToggle} disabled={toggleDisabled} />}
    //   </Box>
    // </Box>

    <Box
      sx={{
        border: '1px solid #CBCBCB',
        borderRadius: '16px',
        p: 1.5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: "#ffffff"
      }}
    >
      {/* Top Section */}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: '12px',
              background: '#00000014',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <RestaurantMenuIcon fontSize="small" />
          </Box>

          <Box>
            <CustomTypography
              variant={"h6"}
              label={title}
              sx={{ color: theme.palette.typographyLabel.main, fontSize: '16px', fontWeight: 700, mb: 0.5 }}
            />

            {itemCount?.toString() &&
              <CustomTypography
                variant={"body2"}
                label={`${itemCount} ${countLabel || (isCount ? 'Chefs' : 'Food Items')}`}
                sx={{ color: theme.palette.text.secondary, fontSize: '12px', fontWeight: 500 }}
              />
            }

            {description &&
              <CustomTypography
                variant={"body2"}
                label={description}
                sx={{
                  color: theme.palette.typographyLabel.main,
                  fontSize: '14px',
                  fontWeight: 300,
                  mb: 0,
                  maxWidth: '250px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              />
            }
          </Box>
        </Box>

        <Chip
          label={enabled ? 'Active' : 'Inactive'}
          size="small"
          sx={{
            bgcolor: enabled ? '#EEF8EE' : "#75757514",
            color: enabled ? '#1F9619' : "#757575",
            fontWeight: 600,
            borderRadius: '20px',
          }}
        />
      </Box>


      {/* Divider */}
      <Divider sx={{ my: 1, borderStyle: 'dashed', }} />

      {/* Bottom Section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {isSwitch && (
          <IOSSwitch
            checked={enabled}
            onChange={onToggle}
            disabled={toggleDisabled}
          />
        )}

        <Box>
          <IconButton
            onClick={onEdit}
            size="small"
            sx={{
              bgcolor: '#EAF7FF',
              mr: 1,
            }}
          >
            <EditIcon sx={{ color: '#1297DE', fontSize: 18 }} />
          </IconButton>

          <IconButton
            onClick={onDelete}
            size="small"
            sx={{
              bgcolor: '#FFF1F1',
            }}
          >
            <DeleteIcon sx={{ color: '#FF4D4F', fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default CategoryCard;
